import Axios from 'axios'
import { DB_URL } from './../../helpers/url'

export const LoginAction=(data)=>{
    return (dispatch)=>{
        dispatch({type:"LOADING"})
        Axios.post(`${DB_URL}/auth/login`,data)
        .then((res)=>{
            console.log(res.data)
            res.data.isLogin = true
            localStorage.setItem('datauser',JSON.stringify(res.data))
            dispatch({type:"LOGIN",payload:res.data})
        }).catch((err)=>{
            alert(err)
        })
    }
}

// export const verifiedaction=(data)=>{
//     return{
//         type:"LOGIN",
//         payload:data
//     }
// }

export const KeepLogin=()=>{
    return (dispatch)=>{
        let datauser = JSON.parse(localStorage.getItem('datauser'))
        if(datauser){
            Axios.get(`${DB_URL}/auth/keeplogin/${datauser.user_id}`)
            .then((res)=>{
                res.data.isLogin = true
                localStorage.setItem('datauser',JSON.stringify(res.data))
                dispatch({type:"LOGIN",payload:res.data})
            }).catch((err)=>console.log(err))
        }
    }
}

export const logout=()=>{
    localStorage.clear();
    return{
        type:'LOGOUT'
    }
}